import {CAPABILITY} from "../../util/Constants";

export const ReceiverGroupByReducer = (state, action) => {

    const defaultGroups = [
        {displayName: "None", value: ""},
        {displayName: "Package Size", value: "PackageSize"},
        {displayName: "EAD", value: "EAD"},
        {displayName: "Cycle", value: "Cycle"},
        {displayName: "Cluster", value: "Cluster"}
    ]

    const ArNextGenApplicableGroups = [
        {displayName: "None", value: ""},
        {displayName: "Package Size", value: "PackageSize"},
        {displayName: "EAD", value: "EAD"}
    ]

    const getApplicableGroups = (capability) => {
        switch (capability) {
            case CAPABILITY.AR_NEXT_GEN:
                return ArNextGenApplicableGroups
            default:
                return defaultGroups
        }
    }

    switch (action.type) {
        case "INITIALIZE_GROUPS":
            return {
                ...state,
                allGroups: getApplicableGroups(action.capability)
            }
        case 'SELECT_GROUP':
            return {
                ...state, selectedGroup: action.selectedGroup
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/receive/reducers/ReceiveGroupByReducer.js